/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum CaseDifficulties {
  None = 0,
  Easy = 1,
  Difficult = 2,
}
